(function () {
  const DEBUG = false;
  const CACHE = Object.create(null);

  const RESULTS_SELECTOR = '.usf-results';
  const PRODUCT_SELECTOR = '.usf-sr-product';

  const GRID_TITLE_SELECTOR = 'a.full-unstyled-link[href*="/products/"]';
  const LIST_TITLE_SELECTOR = '.usf-list .usf-info-column .usf-title';
  const TITLE_SELECTOR = [
    GRID_TITLE_SELECTOR,
    LIST_TITLE_SELECTOR
  ].join(',');

  const PRICE_SELECTOR = '.price-item.price-item--regular';

  function resolveLocalePath() {
    const pathLocale = location.pathname.split('/').filter(Boolean)[0];
    const shopifyLocale = window.Shopify && Shopify.locale;
    const htmlLocale = document.documentElement.lang;

    const locale = pathLocale || shopifyLocale || htmlLocale;

    if (DEBUG) {
      console.log('[title-i18n] locale:', {
        pathLocale,
        shopifyLocale,
        htmlLocale,
        locale
      });
    }

    if (locale === 'th' || locale === 'th-th') return 'th-th';
    if (locale === 'en' || locale === 'en-us') return 'en-us';

    return null;
  }

  const LOCALE_PATH = resolveLocalePath();

  if (!LOCALE_PATH) {
    if (DEBUG) console.warn('[title-i18n] unsupported locale');
    return;
  }

  function injectStyle() {
    if (document.getElementById('title-i18n-style')) return;

    const style = document.createElement('style');
    style.id = 'title-i18n-style';

    style.textContent = `
      ${RESULTS_SELECTOR} ${GRID_TITLE_SELECTOR}:not([data-i18n-title-ready="1"]),
      ${RESULTS_SELECTOR} ${LIST_TITLE_SELECTOR}:not([data-i18n-title-ready="1"]),
      ${RESULTS_SELECTOR} ${PRODUCT_SELECTOR}:not([data-i18n-card-ready="1"]) ${PRICE_SELECTOR} {
        visibility: hidden !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getRoot() {
    return document.querySelector(RESULTS_SELECTOR) || document;
  }

  function getProductCard(el) {
    if (!el) return null;

    return (
      el.closest(PRODUCT_SELECTOR) ||
      el.closest('li') ||
      el.closest('.card-wrapper') ||
      el.closest('.grid__item')
    );
  }

  function getHandleFromUrl(url) {
    try {
      const u = new URL(url, location.origin);
      const match = u.pathname.match(/\/products\/([^\/]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      const match = String(url).match(/\/products\/([^\/\?]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    }
  }

  function getHandleFromTitleElement(el) {
    if (!el) return null;

    let link = null;

    if (el.matches('a[href*="/products/"]')) {
      link = el;
    } else {
      link =
        el.closest('a[href*="/products/"]') ||
        el.closest(PRODUCT_SELECTOR) ||
        el.closest('[href*="/products/"]');
    }

    if (!link || !link.href) return null;

    return getHandleFromUrl(link.href);
  }

  async function fetchTitle(handle) {
    if (!handle) return null;
    if (CACHE[handle]) return CACHE[handle];

    try {
      const url = `/${LOCALE_PATH}/products/${handle}.js`;

      if (DEBUG) console.log('[title-i18n] fetch:', url);

      const res = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!res.ok) {
        if (DEBUG) console.warn('[title-i18n] fetch failed:', res.status, url);
        return null;
      }

      const data = await res.json();

      if (data && data.title) {
        CACHE[handle] = data.title;
        return data.title;
      }
    } catch (e) {
      if (DEBUG) console.warn('[title-i18n] fetch error:', handle, e);
    }

    return null;
  }

  async function translateTitle(el) {
    if (!el) return;

    const card = getProductCard(el);

    if (el.dataset.i18nTitleLoading === '1') return;
    if (el.dataset.i18nTitleReady === '1') {
      if (card) card.dataset.i18nCardReady = '1';
      return;
    }

    const handle = getHandleFromTitleElement(el);

    if (!handle) {
      el.dataset.i18nTitleReady = '1';
      if (card) card.dataset.i18nCardReady = '1';
      return;
    }

    el.dataset.i18nTitleLoading = '1';

    try {
      const title = await fetchTitle(handle);

      if (title && el.textContent.trim() !== title) {
        el.textContent = title;
      }
    } catch (e) {
      if (DEBUG) console.warn('[title-i18n] translate error:', handle, e);
    } finally {
      el.dataset.i18nTitleReady = '1';

      if (card) {
        card.dataset.i18nCardReady = '1';
      }

      delete el.dataset.i18nTitleLoading;
    }
  }

  function translateAll() {
    const root = getRoot();

    const titles = Array.from(root.querySelectorAll(TITLE_SELECTOR));

    if (DEBUG) console.log('[title-i18n] titles found:', titles.length);

    titles.forEach(translateTitle);
  }

  let timer = null;

  function scheduleTranslate() {
    clearTimeout(timer);

    timer = setTimeout(() => {
      translateAll();
    }, 80);
  }

  function start() {
    injectStyle();

    if (DEBUG) console.log('[title-i18n] start');

    translateAll();

    const observer = new MutationObserver(() => {
      scheduleTranslate();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', scheduleTranslate);
    window.addEventListener('pageshow', scheduleTranslate);

    document.addEventListener('shopify:section:load', scheduleTranslate);
    document.addEventListener('shopify:section:select', scheduleTranslate);

    let count = 0;
    const interval = setInterval(() => {
      count += 1;
      translateAll();

      if (count >= 20) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();